/* Small helpers shared across Finance tabs. */

export const SERVICE_LABELS = {
  day_program: 'Explore Program',
  in_home: 'IHCS',
  employment: 'Employment',
  private_pay: 'Private Pay',
};

export const REIMB_STATUS_STYLES = {
  pending: 'bg-[#FFF3E0] text-[#E65100] border-[#FFB74D]',
  approved: 'bg-[#E3F2FD] text-[#1565C0] border-[#64B5F6]',
  paid: 'bg-[#E8F5E9] text-[#1B5E20] border-[#81C784]',
  denied: 'bg-red-50 text-[#D9534F] border-red-300',
};

export const AP_STATUS_STYLES = {
  pending: 'bg-[#FFF3E0] text-[#E65100] border-[#FFB74D]',
  paid: 'bg-[#E8F5E9] text-[#1B5E20] border-[#81C784]',
  overdue: 'bg-red-50 text-[#D9534F] border-red-300',
};

export const AR_STATUS_STYLES = {
  submitted: 'bg-[#E3F2FD] text-[#1565C0] border-[#64B5F6]',
  pending: 'bg-[#FFF3E0] text-[#E65100] border-[#FFB74D]',
  partial: 'bg-[#FFF3E0] text-[#E65100] border-[#FFB74D]',
  paid: 'bg-[#E8F5E9] text-[#1B5E20] border-[#81C784]',
  denied: 'bg-red-50 text-[#D9534F] border-red-300',
};

export function fmtUSD(n) {
  const v = Number(n || 0);
  return v.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
